import { css } from '@linaria/core';
import { theming } from 'styles/utils';
export const footerStyles = "omponents__Footer__Footer_styles_ts-footerStyles-f18riu2q";

require("./Footer.styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./Footer.styles.ts");